export const updateLanguagePack = (lang, langPack) => ({
  type: 'UPDATE_LANG_PACK',
  langPack,
  lang
})

export const fetchLanguage = (lang) => {
  return (dispatch) => {
    import("language/" + lang + ".js").then(langPack => {
      if (typeof(Storage) !== "undefined"){
        localStorage.setItem("lang",lang);
      }
      dispatch(updateLanguagePack(lang, langPack.text));
    });
  }
}


// WEBPACK FOOTER //
// ./src/redux/actions/app.js